import instObj from '@/backend/axios-instances'

const resource = "/orders/details/storage"
const instance = instObj.baseInstance

export default {
  put(id, data, parameters) {
    return instance.put(`${resource}/${id}`, data, { params: parameters });
  },
  delete(id, parameters) {
    return instance.delete(`${resource}/${id}`, { params: parameters });
  }
}
